import React, { useState } from "react";
import { BsPen, BsTrash } from "react-icons/bs";
import { useGlobalContext } from "context/globalContext";
import toast from "react-hot-toast";
import DeleteModal from "components/DeleteModal/DeleteModal";
import { deletePromptVariablesAPI } from "Api/promptVariablesAPI";
import { consoleLog } from "helpers";

const EditOrDeletePromptVariables = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    setPromptVariablesFormData,
    initialPromptVariablesFormState,
    setFetchPromptVariables,
    setIsOpenPromptVariablesEditForm,
  } = useGlobalContext();
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    const token = localStorage.getItem("jwtToken");
    if (isDeleting) return;
    const response = await deletePromptVariablesAPI(
      // deletePromptFragmentsAPI(
      { id: props.cell.row.original.id },
      setIsDeleting,
      token
    );
    if (response) {
      toast.success(`Variable deleted successfully`);
      consoleLog(["Delete successful:", response.data]);
      setFetchPromptVariables(true);
    }
    if (!response) {
      toast.error("Variable deletion failed");
    }
    setIsModalOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFormOpen = () => {
    setPromptVariablesFormData(
      props.cell?.row?.original
        ? {
            ...props.cell.row.original,
            // isActive: props.cell.row.original.isActive ? "active" : "inactive",
          }
        : {
            ...initialPromptVariablesFormState,
            // isActive: initialPromptFragmentsFormState.isActive
            //   ? "active"
            //   : "inactive",
          }
    );
    setIsOpenPromptVariablesEditForm(true);

  };

  return (
    <div className="flex gap-4">
      <BsPen
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleFormOpen}
      />
      <BsTrash
        className="cursor-pointer fill-amber-900 w-5 h-5"
        onClick={handleDeleteClick}
      />
      <DeleteModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default EditOrDeletePromptVariables;
